<template>
  <div>
    <!-- 策略组配置 -->
    <el-dialog
        title="策略组配置"
        :visible.sync="groupConfigVisible"
        width="80%">
        <div>
          <el-form size="small" label-width="140px">
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="公司">
                  <el-select v-model="groupConfigReq.companyId" style="width: 100%;" placeholder="请选择" filterable @change="groupConfigCompanyChange">
                    <el-option
                      v-for="item in company.companyOption"
                      :key="item.id"
                      :label="item.companyName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="策略组">
                  <el-select v-model="groupConfigReq.groupId" style="width: 100%;" filterable placeholder="请选择（非必选项）" @change="groupConfigGroupChange">
                    <el-option
                      v-for="item in groupIdList"
                      :key="item.id"
                      :label="item.companyName + '-' + item.groupName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发送时间">
                  <el-time-picker
                    v-model="groupConfigReq.sendTime"
                    format="HH:mm:ss"
                    value-format="HH:mm:ss">
                  </el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第一行 -->
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="案件状态">
                  <el-select v-model="groupConfigReq.caseStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in caseStatusDefault" :key="item.modelCode" :label="item.modelName" :value="item.modelCode" :title="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="本人状态">
                  <el-select v-model="groupConfigReq.selfStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in selfStatusDefault" :key="item.modelCode" :label="item.modelName" :value="item.modelCode" :title="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="联系人状态">
                  <el-select v-model="groupConfigReq.contactStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in contactStatusDefault" :key="item.modelCode" :label="item.modelName" :value="item.modelCode" :title="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第二行 -->
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="导入时间">
                  <el-date-picker v-model="groupConfigReq.importStartTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker v-model="groupConfigReq.importEndTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="贷款机构">
                  <el-select v-model="groupConfigReq.loanInstitution" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in loanInstitutionList" :key="item" :label="item" :value="item" :title="item"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第三行 -->
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="最后联系时间">
                  <el-date-picker v-model="groupConfigReq.lastAnswerStartTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker v-model="groupConfigReq.lastAnswerEndTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="标签">
                  <el-select v-model="groupConfigReq.labelName" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in labelList" :key="item.name" :label="item.name" :value="item.name" :title="item.name"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="轮次">
                  <el-select v-model="groupConfigReq.replyTimes" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in replyTimesList" :key="item.value" :label="item.label" :value="item.value" :title="item.label"/>
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>
            <!-- 第四行 -->
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="作业停止日">
                  <el-date-picker v-model="groupConfigReq.collectionStartDay" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker v-model="groupConfigReq.collectionEndDay" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="作业状态">
                  <el-select v-model="groupConfigReq.urgeStatus" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in caseUrgeStatusList" :key="item.value" :label="item.label" :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="标签">
                  <el-select v-model="groupConfigReq.labelName" filterable multiple collapse-tags placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in labelList" :key="item.name" :label="item.name" :value="item.name" :title="item.name"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-dropdown @command="labelChange"  style="position:relative;top:5px;left:8%">
                    <span class="el-dropdown-link">
                      {{groupConfigReq.label}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="aCaseId,进件号"> 进件号</el-dropdown-item>
                      <el-dropdown-item command="mobile,手机号"> 手机号</el-dropdown-item>
                      <el-dropdown-item command="name,姓名"> 姓 名</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-form-item>
                    <el-input v-model="groupConfigReq.keyStr" placeholder="请选择" style="position:relative;top: -20px;"></el-input>
                  </el-form-item>
              </el-col>
            </el-row> -->
            <!-- 第五行 -->
            <el-row :gutter="12">
              <el-col :span="12" style="margin-top: -1%;">
                <el-form-item label="AI评分">
                  <el-col :span="4">
                    <el-switch v-model="groupConfigReq.aiSelected"/>
                  </el-col>
                  <el-col :span="16">
                    <transition name="component-fade" mode="out-in">
                      <el-slider v-if="groupConfigReq.aiSelected" v-model="groupConfigReq.difficultyScore" range :min="0" :max="100"/>
                    </transition>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="margin-top: -1%;">
                <el-form-item label="逾期天数">
                  <el-col :span="4">
                    <el-switch v-model="groupConfigReq.overdueDatesSelected"/>
                  </el-col>
                  <el-col :span="16">
                    <transition name="component-fade" mode="out-in">
                      <el-slider v-if="groupConfigReq.overdueDatesSelected" v-model="groupConfigReq.overdueDates" range :min="-50" :max="365"/>
                    </transition>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="12">
                <el-form-item label="是否开启">
                  <el-switch v-model="groupConfigReq.status"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="groupConfigVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="submitGroupConfig" size="small">保存</el-button>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import BatchSelector from '../../../../components/bussiness-select/BatchSelector';
import CaseStatusSelector from '../../../../components/bussiness-select/CaseStatusSelector';
import SelfStatusSelector from '../../../../components/bussiness-select/SelfStatusSelector';
import ContactStatusSelector from '../../../../components/bussiness-select/ContactStatusSelector';

export default {
  inject: ['reload'],
  props: {
    company: {
    }
  },
  watch: {
  },
  data() {
    return {
      groupConfigVisible: false,
      groupConfigReq: {
        id: null,
        companyId: null,
        groupId: null,
        // 搜索条件
        keyType: 'aCaseId',
        keys: [],
        caseStatus: [],
        selfStatus: [],
        contactStatus: [],
        importStartTime: null,
        importEndTime: null,
        loanInstitution: [],
        strategyGroup: [],
        lastAnswerStartTime: null,
        lastAnswerEndTime: null,
        replyTimes: [],
        labelName: [],
        collectionStartDay: null,
        collectionEndDay: null,
        aiSelected: false,
        overdueDatesSelected: false,
        difficultyScore: [null, null],
        overdueDates: [null, null],
        urgeStatus: [],
        label: '进件号',
        keyStr: null,
        status: false,
        sendTime: null
      },
      caseStatusDefault: [],
      selfStatusDefault: [],
      contactStatusDefault: [],
      loanInstitutionList: [],
      caseUrgeStatusList: [
        { value: '1', label: '作业中' },
        { value: '-1', label: '暂停作业' },
        { value: '2', label: '作业完成' }
      ],
      replyTimesList: [
        {
          value: 'REPLY_TIMES_ONE',
          label: '0'
        },
        {
          value: 'REPLY_TIMES_TWO',
          label: '1'
        },
        {
          value: 'REPLY_TIMES_THREE',
          label: '2-5'
        },
        {
          value: 'REPLY_TIMES_FOUR',
          label: '6-10'
        },
        {
          value: 'REPLY_TIMES_FIVE',
          label: '>10'
        }
      ],
      labelList: [],
      groupIdList: []
    };
  },
  mounted() {
    this.caseStatusSearch();
    this.selfStatusSearch();
    this.zhixiContactStatusSearch();
  },
  methods: {
    addOrEditGroupConfig() {
      this.initialGroupConfig();
      this.loanInstitutionSearch();
      this.labelSearch();
      this.groupConfigVisible = true;
    },
    initialGroupConfig() {
      this.groupConfigReq = {
        id: null,
        companyId: null,
        groupId: null,
        // 搜索条件
        keyType: 'aCaseId',
        keys: [],
        caseStatus: [],
        selfStatus: [],
        contactStatus: [],
        importStartTime: null,
        importEndTime: null,
        loanInstitution: [],
        strategyGroup: [],
        lastAnswerStartTime: null,
        lastAnswerEndTime: null,
        replyTimes: [],
        labelName: [],
        collectionStartDay: null,
        collectionEndDay: null,
        aiSelected: false,
        overdueDatesSelected: false,
        difficultyScore: [null, null],
        overdueDates: [null, null],
        urgeStatus: [],
        label: '进件号',
        keyStr: null,
        status: false,
        sendTime: null
      };
    },
    // 策略组配置提交
    submitGroupConfig() {
      console.warn(this.groupConfigReq);
      if (this.groupConfigReq.companyId === null) {
        this.$message({
          message: '请选择公司',
          type: 'warning'
        });
        return;
      }
      if (this.groupConfigReq.groupId === null) {
        this.$message({
          message: '请选择策略组',
          type: 'warning'
        });
        return;
      }
      if (this.groupConfigReq.sendTime === null) {
        this.$message({
          message: '请选择发送时间',
          type: 'warning'
        });
        return;
      }
      if (this.groupConfigReq.keyStr === null || this.groupConfigReq.keyStr === '') {
        this.groupConfigReq.keyType = null;
        this.groupConfigReq.keys = [];
      } else {
        this.groupConfigReq.keys = this.groupConfigReq.keyStr.split(',');
      }
      this.$ajax({
        prompt: true,
        url: 'strategy/updateOrInsertGroupConfig',
        data: this.groupConfigReq
      }).then(() => {
        this.groupConfigVisible = false;
      });
    },
    // 公司变更
    groupConfigCompanyChange() {
      const search = {};
      search.companyIds = this.groupConfigReq.companyId === null ? [] : [this.groupConfigReq.companyId];
      if (search.companyIds.length === 0) {
        this.groupIdList = [];
        return;
      }
      this.$ajax({
        url: 'strategy/updateTemplateCompanyChange',
        data: search
      }).then((res) => {
        this.groupIdList = res.data;
      });
    },
    // 策略组变更
    groupConfigGroupChange() {
      const search = {};
      search.companyId = this.groupConfigReq.companyId;
      search.groupId = this.groupConfigReq.groupId;
      this.$ajax({
        url: 'strategy/getGroupConfig',
        data: search
      }).then((res) => {
        if (res.data) {
          this.groupConfigReq = res.data;
        } else {
          this.initialGroupConfig();
          this.groupConfigReq.companyId = search.companyId;
          this.groupConfigReq.groupId = search.groupId;
        }
      });
    },
    labelChange(command) {
      console.warn(command);
      this.groupConfigReq.keyType = command.split(',')[0];
      this.groupConfigReq.label = command.split(',')[1];
    },
    loanInstitutionSearch() {
      this.$ajax({
        method: 'GET',
        url: '/robotCase/getLoanInstitutionsList'
      }).then((res) => {
        this.loanInstitutionList = res.data;
      });
    },
    labelSearch() {
      this.$ajax({
        method: 'GET',
        url: '/label/getLable'
      }).then((res) => {
        this.labelList = res.data;
      });
    },
    // 案件状态下拉框
    caseStatusSearch() {
      this.$ajax({
        method: 'GET',
        url: '/dict/getList/caseStatus',
        params: { 'val': '' }
      }).then((res) => {
        this.caseStatusDefault = res.data;
      });
    },
    // 联系人状态下拉框
    selfStatusSearch() {
      this.$ajax({
        method: 'GET',
        url: '/dict/getList/benrendianhuaContactStatus',
        params: { 'val': '' }
      }).then((res) => {
        this.selfStatusDefault = res.data;
      });
    },
    // 本人状态下拉框
    zhixiContactStatusSearch() {
      this.$ajax({
        method: 'GET',
        url: '/dict/getList/zhixidianhuaContactStatus',
        params: { 'val': '' }
      }).then((res) => {
        this.contactStatusDefault = res.data;
      });
    }
  },
  components: {
    BatchSelector,
    CaseStatusSelector,
    SelfStatusSelector,
    ContactStatusSelector
  }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/group_config.vue